module.exports = __webpack_public_path__ + "static/media/buttonProduct_who.91026381.png";